import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const PlusCircle = (param)=>{
    let { size = 24, testId, style, className } = param;
    const strokeWidth = 1.5 * (24 / size);
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: strokeWidth
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8 12H16M12 16V8",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round"
            })
        ]
    });
};
